import { AdminVideo } from '../model/dto/video/admin-video';
import { UpdateVideoRequest } from '../model/dto/video/video-requests';
import { VideoDetailsValues } from '../model/type/video-details.types';

export const toVideoDetailsUpdate = (
  video: AdminVideo,
  { title, description }: VideoDetailsValues
): UpdateVideoRequest => {
  const nextTitle = title.trim();
  const nextDescription = description.trim() || null;

  return {
    ...(nextTitle !== video.title ? { title: nextTitle } : {}),
    ...(nextDescription !== video.description
      ? { description: nextDescription }
      : {}),
  };
};
